import actionTypes from '../constants/action-types';

const upgradeOptions = (state = {}, action) => {
  if (action.type !== actionTypes.SET_UPGRADE_OPTIONS) return state;

  return action.payload.options;
};

export default upgradeOptions;
